// extracted by mini-css-extract-plugin
export var columnList = "_cw-0";